'use client';

import { useEffect, useState } from 'react';

import type { Theme } from '../themes/DefaultTheme';
import { DefaultTheme } from '../themes/DefaultTheme';
import { DarkTheme } from '../themes/DarkTheme';

export interface MediaQueryEvent {
  matches: boolean;
  media: string;
}

export const useSystemTheme = (defaultTheme: Theme = DefaultTheme) => {
  const [themeState, setTheme] = useState<Theme>(DefaultTheme);

  useEffect(() => {
    const { matchMedia } = window;

    if (!matchMedia) {
      return;
    }

    const media = matchMedia('(prefers-color-scheme: dark)');

    const mediaHandler = (event: { matches: boolean }) => {
      if (event.matches) {
        setTheme(DarkTheme);
      } else {
        setTheme(DefaultTheme);
      }
    };

    mediaHandler(media);

    media.addListener(mediaHandler);

    return () => {
      media.removeListener(mediaHandler);
    };
  }, [defaultTheme]);

  return themeState;
};
